import { Platform } from 'quasar'
import { DeviceType, PlatformName } from './platform/types'

type TPlatformComposable = {
  isAppleHandheldDevice: () => boolean
  isDesktopDevice: () => boolean
  isTouchDevice: () => boolean
  isMacSafari: () => boolean
  getPlatformName: () => PlatformName
  getDeviceType: () => DeviceType
  isPWA: () => boolean
}

export const usePlatform = (): TPlatformComposable => {
  const isAppleHandheldDevice = (): boolean => {
    return !!(Platform.is.ios || Platform.is.ipad || Platform.is.ipod || Platform.is.iphone)
  }

  const isTouchDevice = (): boolean => {
    return !!(
      Platform.is.mobile ||
      Platform.is.ios ||
      Platform.is.android ||
      Platform.is.ipad ||
      Platform.is.ipod ||
      Platform.is.iphone
    )
  }

  const isDesktopDevice = (): boolean => {
    return !!Platform.is.desktop
  }

  const isMacSafari = (): boolean => {
    return !!Platform.is.safari && !!Platform.is.desktop && !!Platform.is.mac
  }

  const getPlatformName = (): PlatformName => {
    const { is } = Platform

    if (is.ios) {
      return PlatformName.IOS
    }

    if (is.ipad) {
      return PlatformName.IPAD
    }

    if (is.iphone) {
      return PlatformName.IPHONE
    }

    if (is.ipod) {
      return PlatformName.IPOD
    }

    if (is.android) {
      return PlatformName.ANDROID
    }

    if (is.mac) {
      return PlatformName.MAC
    }

    if (is.win) {
      return PlatformName.WINDOWS
    }

    if (is.linux) {
      return PlatformName.LINUX
    }

    if (is.chrome) {
      return PlatformName.CHROME
    }

    if (is.firefox) {
      return PlatformName.FIREFOX
    }

    if (is.safari) {
      return PlatformName.SAFARI
    }

    if (is.opera) {
      return PlatformName.OPERA
    }

    if (is.edge) {
      return PlatformName.EDGE
    }

    return PlatformName.UNKNOWN
  }

  const getDeviceType = (): DeviceType => {
    return isTouchDevice() ? DeviceType.MOBILE : DeviceType.DESKTOP
  }

  const isPWA = (): boolean => {
    return (
      window.matchMedia('(display-mode: standalone)').matches ||
      window.matchMedia('(display-mode: fullscreen)').matches ||
      window.matchMedia('(display-mode: minimal-ui)').matches
    )
  }

  return {
    isAppleHandheldDevice,
    isDesktopDevice,
    isTouchDevice,
    isMacSafari,
    getPlatformName,
    getDeviceType,
    isPWA,
  }
}
